/*
 * @Author: seven.zhang 
 * @Date: 2019-02-13 14:34:38 
 * @Last Modified by: seven.zhang
 * @Last Modified time: 2021-05-06 16:30:19
 * 自定义axios， 数据拦截处理
 */
import axios from 'axios'
import md5 from 'js-md5'
import baseURL from '@/config/env.js'
import moment from 'moment'
// import store from "../../../../land/land-web/src/store";
let _baseUrl = baseURL.apiUrl

const service = axios.create({
    baseURL: _baseUrl,
    timeout: 60000000
})

/**
 * 请求拦截
 */

service.interceptors.request.use(
    function(config) {
        // console.log(config)

        let time = new Date().getTime()
        time = parseInt(time / 1000)

        // 设置token失效时间(此处为30分钟)
        let startTime = localStorage.getItem('sZfyxTime')
        let endTime = moment()
        let diff = endTime.diff(startTime, 'minute')
        let uid = localStorage.getItem('sZfyxUid')
        // 针对大屏用户，不做30分钟登录失效处理
        if (uid != 8706 && diff >= 30) {
            localStorage.removeItem('sZfyxToken')
        } else {
            localStorage.setItem('sZfyxTime', moment())
        }

        // 验签
        config.headers['time'] = time
        config.headers['sign'] = md5(`${time}081f8bl5b4ef678azfyx88a6bcce3598ne514bffcd7383e4e0b`)

        // token
        let token = localStorage.getItem('sZfyxToken')

        let sourceUrl = window.location.href
        let sApiType = config.data && config.data.data && config.data.data.sApiType ? false : true

        if (!token && sApiType) {
            window.location.href = 'http://youcaiyun.com/Pages/Account/Login.aspx?tourl=' + sourceUrl
        }

        config.headers['token'] = encodeURIComponent(token)

        // 导出excel 参数必须传 iExport:1
        if ((config.params && config.params.iExport == 1) || (config.data && config.data.iExport == 1)) {
            config.responseType = 'arraybuffer'
        }

        return config
    },
    function(error) {
        return Promise.reject(error)
    }
)

/**
 * 响应拦截
 */
service.interceptors.response.use(
    function(response) {
        return response.data
    },
    function(error) {
        return Promise.reject(error)
    }
)

export default service
